import { render, staticRenderFns } from "./StoreVatForm.vue?vue&type=template&id=13092bfe&"
import script from "./StoreVatForm.vue?vue&type=script&lang=js&"
export * from "./StoreVatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports